import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';
import { Facet } from '~model/facet';
import { FacetOption } from '~model/facet-option';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-facet-option-list',
})
export class FacetOptionList {
  @Prop() facet: Facet;
  @State() open = false;
  @State() showMore = false;

  @Event() facetChanged: EventEmitter<Facet>;

  toggle() {
    this.open = !this.open;
  }

  select(option: FacetOption) {
    option.selected = !option.selected;
    this.facet.used = this.facet.options.some(option => option.selected);
    this.facetChanged.emit(this.facet);
  }

  reset() {
    this.facet.used = false;
    this.facet.options.forEach(option => (option.selected = false));
    this.facetChanged.emit(this.facet);
  }

  renderFacetOptions() {
    const options = this.showMore ? this.facet.options : this.facet.options.slice(0, 5);
    return (
      <ul class="facet-option-list">
        {options.map((option: FacetOption) => {
          const props = {
            role: 'button',
            class: `${option.selected ? 'selected' : ''}`,
            onClick: () => this.select(option),
            title: option.label,
          };
          return (
            <li>
              <a {...props}>{option.label}</a>
            </li>
          );
        })}
      </ul>
    );
  }

  renderShowMore() {
    return !this.showMore && this.facet.options.length > 5 ? (
      <a role="button" class="facet-more" onClick={() => (this.showMore = true)}>
        <svg width="12" height="12">
          <use href="#fa-angle-double-right"></use>
        </svg>
        {translate('sw.listing.filter.more')}
      </a>
    ) : (
      ''
    );
  }

  renderReset() {
    if (!this.facet.used) {
      return;
    }
    return (
      <a role="button" class="facet-reset" onClick={() => this.reset()}>
        <svg width="12" height="12">
          <use href="#fa-angle-double-right"></use>
        </svg>
        {translate('sw.listing.filter.reset')}
      </a>
    );
  }

  render() {
    if (!this.facet) {
      return '';
    }
    return (
      <Host
        id={'facet-option-' + this.facet.id}
        class={{
          'facet-option': true,
          'facet-option-open': this.open,
        }}
      >
        <a role="button" class={this.facet.used ? 'facet-label facet-label-selected' : 'facet-label'} onClick={_ => this.toggle()}>
          {this.facet.label}
          <span class="check" />
        </a>
        {this.renderFacetOptions()}
        {this.renderShowMore()}
        {this.renderReset()}
      </Host>
    );
  }
}
